import { Checkbox as MuiCheckbox, FormControlLabel, FormControl, FormGroup } from '@mui/material';
import { withStyles } from '@mui/styles';
import { useCallback } from 'react';

const styles = () => ({
    checkboxLabel: {
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '20px',
    },
});

const CheckboxList = ({ classes, field, options, render }) => {
    const renderLabel = (item) => {
        const value = typeof item === 'object' ? item.label : item;
        if (render) return render(value);
        return value;
    };

    const handleClick = useCallback(
        (e) => {
            const selectedItemValue = e.target.value;

            let newSelectedItems = [];
            if (e.target.checked) {
                newSelectedItems = [...field.value, selectedItemValue];

                const selectedItem = options.find((item) =>
                    typeof item === 'object'
                        ? item?.value === selectedItemValue
                        : item === selectedItemValue
                );
                // If the selected item has excluded items, remove the excluded items from the new selected items
                if (Array.isArray(selectedItem?.exclude) && selectedItem.exclude?.length > 0) {
                    newSelectedItems = newSelectedItems.filter(
                        (item) => !selectedItem.exclude.includes(item)
                    );
                }
            } else {
                newSelectedItems = field.value.filter((s) => s !== selectedItemValue);
            }

            field.onChange(newSelectedItems);
        },
        [field, options]
    );

    return (
        <FormControl component="fieldset">
            <FormGroup>
                {options?.map((item) => (
                    <FormControlLabel
                        key={typeof item === 'object' ? item.value : item}
                        control={
                            <MuiCheckbox
                                checked={field.value.includes(
                                    typeof item === 'object' ? item.value : item
                                )}
                                {...field}
                                onChange={handleClick}
                                value={typeof item === 'object' ? item.value : item}
                                color="primary"
                            />
                        }
                        classes={{ label: classes.checkboxLabel }}
                        label={renderLabel(item)}
                    />
                ))}
            </FormGroup>
        </FormControl>
    );
};

export default withStyles(styles)(CheckboxList);
